export default __webpack_public_path__ + "static/photoelectric12-edf3c074c39d056fddccfc96fb7e531d.png";